import { Flex } from "@hopper-ui/components";

import { forwardRef, type ComponentProps } from "react";

import { useTranslation } from "react-i18next";
import "./AppLoading.css";

export function AppLoading() {
    const { t } = useTranslation();

    return (
        <Flex width="100%" UNSAFE_height="100vh" alignItems="center" justifyContent="center">
            <WorkleapIcon className="wl-page-loader-pulse" aria-label={t("loading")} height="104px" width="104px" />
        </Flex>
    );
}

const WorkleapIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>((props, ref) => {
    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 480 480"
            ref={ref}
            {...props}
        >
            <rect
                width="480"
                height="480"
                rx="102.806"
                fill="#2545FF"
            >
            </rect>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M234.924 259.14L203.904 364.323C203.623 365.274 203.031 366.084
                202.252 366.676C201.458 367.268 200.507 367.579 199.526 367.595H137.75C136.581
                367.595 135.444 367.205 134.524 366.504C133.59 365.803 132.92 364.806 132.608
                363.684L65.3165 124.557H135.039L171.123 256.46L209.014 128.437C209.357 127.315
                210.042 126.333 210.977 125.632C211.896 124.947 213.034 124.557 214.202
                124.557H272.566C273.548 124.557 274.514 124.869 275.309 125.445C276.103
                126.022 276.695 126.847 276.976 127.782L310.442 234.009L346.386
                124.557H415.391L350.889 316.585C350.468 317.847 349.658 318.953 348.567
                319.717C347.492 320.496 346.184 320.916 344.859 320.916H281.696C280.544
                320.916 279.406 320.558 278.471 319.872C277.536 319.187 276.835 318.221
                276.493 317.115L217.661 133.983C217.537 133.578 217.287 133.235 216.944
                132.986C216.602 132.737 216.197 132.612 215.776 132.612C215.355 132.612
                214.95 132.752 214.623 133.002C214.296 133.251 214.047 133.609 213.922
                134.014L167.337 292.747C191.72 287.107 214.405 276.356 234.924 259.14ZM284.516
                313.625L308.105 238.153C301.78 219.332 290.406 218.055 274.467 226.702C268.001
                230.799 265.041 232.7 257.64 238.262L280.715 313.64C280.84 314.045 281.104 314.404
                281.447 314.653C281.79 314.902 282.211 315.042 282.631 315.042C283.052 315.042
                283.473 314.902 283.815 314.653C284.158 314.404 284.407 314.045 284.548
                313.64H284.516V313.625ZM160.481 294.134L141.193 357.514C141.084 357.904
                140.834 358.247 140.507 358.48C140.258 358.667 139.978 358.777 139.682
                358.823C139.385 358.87 139.074 358.823 138.778 358.745C138.482 358.667
                138.233 358.48 138.014 358.262C137.796 358.044 137.656 357.764 137.563
                357.483L121.624 296.315C134.337 297.281 147.3 296.424 160.466 294.134H160.481Z"
                fill="#F0E9E1"
            ></path></svg>
    );
});
